<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="label"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="true"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :multiple="isMultiple"
    :hide-selected="true"
    :close-on-select="isCloseOnSelect"
    class="multiselect-primary"
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="tag" slot-scope="{ option }">
      <span class="badge badge-primary mr-1">
        <span class="text-truncate mr-1 mb-1">
          {{ option.nome }}
        </span>
        <span class="custom__remove badge" @mousedown.prevent.stop="removeOption(option)"> x </span>
      </span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: {
    nameField: {},
    isRequired: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    emptyLabel: { type: String, default: null },
    includeAll: { type: Boolean, default: false },
    isMultiple: { type: Boolean, default: false },
    isTagabble: { type: Boolean, default: false },
    notRemove: {},
    onlyCompanyLogged: { type: Boolean, default: false },
    isCloseOnSelect: { type: Boolean, default: true }
  },

  data() {
    return {
      selected: [],
      options: [],
      value: [],
      empresasDefault: [],
      isLoading: false
    };
  },

  methods: {
    removeOption(option) {
      if (!option) return;

      if (this.notRemove && option.id == this.notRemove) {
        this.$util.formWarn({
          msgTitle: 'Ação não Permitida',
          msgContent: 'Não é permitido remover a empresa de cadastro',
          type: 'error'
        });
        return;
      }
      const idx = this.selected.findIndex((e) => e.id === option.id);
      this.selected.splice(idx, 1);

      let arr = [];
      this.selected.forEach((el) => {
        arr.push(el.id);
      });

      this.$emit('selectChange', 'id_empresa', arr);
    },
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_empresa', null);
        return;
      }
      if (this.isMultiple) {
        let arr = [];
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'id_empresa', arr);
      } else {
        this.$emit('selectChange', 'id_empresa', e.id);
      }
      this.$emit('focus');
    },
    label({ nome, id }) {
      if (this.isMultiple) {
        return `${id} - ${nome}`;
      } else {
        return nome;
      }
    },
    setValue(value) {
      if (this.isMultiple) {
        this.selected = [];
        if (value || value.length > 0) {
          value.forEach((el) => {
            const findElem = this.options.find((option) => option.id === el);
            if (!!findElem) {
              this.selected.push(findElem);
            }
          });
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
      } else {
        if (value) {
          this.selected = this.options.find((option) => option.id === value);
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getEmpresas({
          columns: 'id, nome'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);

          if (this.empresasDefault.length > 0) {
            if (this.nameField.length > 0) {
              this.setValue(this.nameField);
            } else {
              this.setValue(this.empresasDefault);
              this.$emit('selectChange', 'id_empresa', this.empresasDefault);
            }
          } else {
            this.setValue(this.nameField);
          }

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  created() {
    let id_empresas = null;

    if (!this.onlyCompanyLogged) {
      if (this.$store.state.user.info.empresas) {
        id_empresas = this.$store.state.user.info.empresas;
      } else if (this.$store.state.user.info.empresas_preferenciais) {
        id_empresas = this.$store.state.user.info.empresas_preferenciais;
      } else {
        id_empresas = this.$store.state.user.info.id_empresa.toString();
      }
    } else {
      id_empresas = this.$store.state.user.info.id_empresa.toString();
    }

    this.empresasDefault = id_empresas.split(',').map((x) => +x);

    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      if (this.options.length > 0) {
        this.setValue(value);
      } else {
        this.setOptions();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
